// Authoritative MIME-type list for XLSX file validation.
//
// Browsers and operating systems label .xlsx uploads inconsistently:
// - Chrome / Edge: application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
// - Safari / older Chrome: application/octet-stream
// - Some Windows clients: application/vnd.ms-excel
// - Drag-drop from Finder / Explorer: empty string
//
// Both frontend (isXlsxCandidate) and backend (isXlsxFile) must use this
// exact list so valid uploads are never rejected client-side while the
// server would have accepted them.

export const XLSX_MIME_TYPES = Object.freeze([
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'application/octet-stream',
] as const)

export type XlsxMimeType = (typeof XLSX_MIME_TYPES)[number]
